Postlogin = (function (postlogin) {
    postlogin.BulkLessonSelection = {};
    const self = postlogin.BulkLessonSelection;

    let lessonSelections = [];
    const $lessonsTable = $('#lessons-table');

    self.init = () => {
        self.initEvents();
        initBootstrapTable();
        new self.BulkLessonAssignmentEvents();
    };

    self.initEvents = function () {
        // Ported from bootstrap-select to Tom Select 2026-05-11.
        const licenseSelect = document.getElementById('license');
        if (licenseSelect) {
            // eslint-disable-next-line no-new
            new TomSelect(licenseSelect, {
                placeholder: 'All licenses selected',
                plugins: ['remove_button'],
                diacritics: true,
                maxOptions: null,
            });
        }
    };

    // Uses VjsUtility.Controller for Events, uses VjsUtility.Request for ajax calls
    self.BulkLessonAssignmentEvents = VjsUtility.Controller.extend({
        events: {
            'change #license': 'licenseChange',
            'submit #bulk-assign-form': 'submitBulkAssignment',
        },

        licenseChange() {
            $lessonsTable.bootstrapTable('refresh');
        },

        submitBulkAssignment(e) {
            e.preventDefault();
            const submitButton = $('#create-update-assignment');
            submitButton.prop('disabled', true);

            const input = $('<input>').attr('type', 'hidden').attr('name', 'lesson_selections').val(lessonSelections);
            $(e.currentTarget).append(input);

            const submit = new VjsUtility.Request();
            const submitUrl = $(e.currentTarget).prop('action');
            const students = $('#selected-students-list')
                .find('li.list-item')
                .map((index, student) => $(student).data('user-id'))
                .get();
            const lessons = $('#lessons-table')
                .bootstrapTable('getSelections')
                .map((lesson) => ({
                    lesson_id: lesson.lesson_id,
                    completion_type: $(`#completion_type-${lesson.lesson_id}`).val(),
                    subtitle: $(`#subtitle-${lesson.lesson_id}`).val(),
                    fast_forward_allowed: 0,
                }));

            submit
                .post(submitUrl, {
                    students: JSON.stringify(students),
                    lessons,
                })
                .done((data) => {
                    VjsUtility.Notification.success({
                        title: 'Successfully Assigned Lesson(s)',
                        text: data.data.message,
                    });

                    setTimeout(() => {
                        window.location.href = '/lessons/';
                    }, 2000);
                })
                .fail(() => {
                    submitButton.prop('disabled', false);

                    VjsUtility.Notification.error({
                        title: 'Error',
                        text: 'There were errors trying to assign lessons',
                    });
                });
        },
    });

    const initBootstrapTable = function () {
        const userSelectionLock = $('#student-group-selection-form').find('.lock-selection');

        if ($lessonsTable.data('preselected-ids') !== undefined) {
            lessonSelections = $lessonsTable.data('preselected-ids');
        }

        $lessonsTable.bootstrapTable({
            formatNoMatches() {
                return 'No lessons to show';
            },
            onCheck(row) {
                addLesson(row);

                // once a lesson has been selected allow user selection to happen
                userSelectionLock.hide();
            },
            onUncheck(row) {
                removeLesson(row.lesson_id);

                if ($lessonsTable.bootstrapTable('getSelections').length === 0) {
                    // prevent groups/users selection
                    userSelectionLock.show();
                }
            },
            onCheckAll(rows) {
                for (let i = 0; i < rows.length; i += 1) {
                    addLesson(rows[i]);
                }
            },
            onUncheckAll(rows) {
                for (let i = 0; i < rows.length; i += 1) {
                    removeLesson(rows[i].lesson_id);
                }
            },

            toolbar: '.table-toolbar',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'lesson_id',
            minimumCountColumns: '2',
            pagination: false,
            search: true,
            sortName: 'grade_band',
            sortOrder: 'asc',
            pageSize: 1000,
            clickToSelect: false,
            maintainSelected: true,
            sidePagination: 'client',
            url: '/lessons/json/',
            queryParamsType: 'other',
            queryParams(params) {
                const tableParams = {};
                tableParams.search_term = params.searchText;
                tableParams.page = params.pageNumber;
                tableParams.page_size = params.pageSize;
                tableParams.order_by = params.sortName;
                tableParams.sort_order = params.sortOrder;
                tableParams.published = 1;

                return tableParams;
            },
            columns: [
                {
                    // sr-only header text so bootstrap-table's
                    // select-all <th> isn't flagged as empty.
                    title: '<span class="sr-only">Select row</span>',
                    field: 'checkbox',
                    align: 'center',
                    valign: 'middle',
                    checkbox: true,
                },
                {
                    title: 'Lesson ID',
                    field: 'lesson_id',
                    sortable: false,
                    align: 'center',
                },
                {
                    title: 'Image',
                    field: 'lesson_image',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter(value, row) {
                        return !value ? '' : `<img src="${row.lesson_image}" style="width: 80px;"/>`;
                    },
                },
                {
                    title: 'Lesson',
                    field: 'name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Grades',
                    field: 'grade_band',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Subtitle',
                    field: 'subtitle',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        return `
                            <input type="text" class="form-control" id="subtitle-${row.lesson_id}"
                                name="subtitle[${row.lesson_id}]" placeholder="Subtitle (optional)"
                                lang="en">
                        `;
                    },
                },
                {
                    title: 'Completion Type',
                    field: 'completion_type',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        return `
                            <select class="form-control completion-type-select" 
                                id="completion_type-${row.lesson_id}" name="completion_type[${row.lesson_id}]">
                                <option value="student">Student Driven</option>
                                <option value="teacher">Teacher Guided</option>
                            </select>
                        `;
                    },
                },
            ],
            responseHandler(res) {
                return res.data;
            },
        });
    };

    const addLesson = (lesson) => {
        if (lessonSelections !== undefined && lessonSelections.indexOf(lesson.lesson_id) === -1) {
            lessonSelections.push(lesson.lesson_id);
        }
    };

    const removeLesson = (lessonId) => {
        if (lessonSelections !== undefined && lessonSelections.indexOf(+lessonId) !== -1) {
            const index = lessonSelections.indexOf(+lessonId);
            lessonSelections.splice(index, 1);
        }
    };

    return postlogin;
}(Postlogin || {}));
